var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 34,
    viewBox: "0 0 44 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8122 26.5671C14.8122 24.0649 17.0687 22.0411 19.9074 22.0411H36.9032L32.3176 26.6407L14.8122 26.5671ZM18.7428 34C19.7618 31.0931 22.6005 29.1061 25.8031 29.1061H29.7701L24.8933 34H18.7428ZM0 19.539L4.76758 14.6818L44 14.7186L39.2688 19.539H0ZM29.3333 7.28571C29.3333 9.97186 27.0769 12.1797 24.2382 12.1797H7.24235L12.1191 7.28571H29.3333ZM25.5484 0C24.5294 2.90693 21.6907 4.89394 18.488 4.89394H14.5211L19.3251 0H25.5484Z",
    fill: "url(#paint0_linear_609_12561)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_609_12561",
    x1: 140.347,
    y1: -0.0147186,
    x2: 140.347,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2E2E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#692C81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolera);
export default __webpack_public_path__ + "static/media/solera.92234a3874f90bcaf699a142005a5847.svg";
export { ForwardRef as ReactComponent };